export default __webpack_public_path__ + "static/media/940.5680fca7.jpg";